import { forwardRef, TextareaHTMLAttributes } from 'react'
import { cn } from '@/lib/utils'

export interface TextareaProps
  extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  error?: boolean
}

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, error, ...props }, ref) => {
    return (
      <textarea
        ref={ref}
        className={cn(
          'w-full px-3 py-2 border rounded-lg',
          'text-brown-900 placeholder:text-brown-400',
          'focus:outline-none focus:ring-2 focus:ring-mint-500 focus:border-transparent',
          'disabled:bg-beige-100 disabled:cursor-not-allowed',
          'resize-y min-h-[100px]',
          error
            ? 'border-red-300 focus:ring-red-500'
            : 'border-beige-300',
          className
        )}
        {...props}
      />
    )
  }
)

Textarea.displayName = 'Textarea'
